import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getDSDVDaChiDinh } from 'src/app/modules/phan-he-kham-benh/services/ChiDinhDVService';
import { RESPONSE_MESSAGE } from 'src/app/modules/utils/Constant';
import { LOAI_BENH_AN } from 'src/app/modules/phan-he-kham-benh/constants/BenhAn';
import { useBenhAnContext } from 'src/app/modules/phan-he-kham-benh/contexts/BenhAnContext';
import DanhSachDichVu from '../phieu-xet-nghiem/components/DanhSachDichVu';
import ThongTinPhieu from '../phieu-xet-nghiem/components/ThongTinPhieu';
import { columnsDSChuyenKhoa } from './constant';

const PhieuChuyenKhoa = () => {
	const { phieuBenhAn } = useBenhAnContext();

	const [data, setData] = useState<any>();

	useEffect(() => {
		if (LOAI_BENH_AN.PHIEU_CHUYEN_KHOA === phieuBenhAn?.displayCode) {
			getDetailPhieu();
		}
	}, [phieuBenhAn?.id, phieuBenhAn?.displayCode]);

	const getDetailPhieu = async () => {
		try {
			const { data } = await getDSDVDaChiDinh({
				orderGroupId: phieuBenhAn?.id,
			});

			setData({
				...phieuBenhAn,
				terms: data.data,
			});
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<div className="spaces p-10">
			<ThongTinPhieu data={data} />
			<DanhSachDichVu data={data?.terms} columns={columnsDSChuyenKhoa} />
		</div>
	);
};

export default PhieuChuyenKhoa;
